import { render, staticRenderFns } from "./BTPortalCollapse.vue?vue&type=template&id=b9f5d9d8&scoped=true&"
import script from "./BTPortalCollapse.vue?vue&type=script&lang=ts&"
export * from "./BTPortalCollapse.vue?vue&type=script&lang=ts&"
import style0 from "./BTPortalCollapse.vue?vue&type=style&index=0&id=b9f5d9d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f5d9d8",
  null
  
)

export default component.exports